//is touch device
function isTouchDevice(){
	return (('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}

//is scroll
function isScroll() {
	let position = 0, showFlag = false, vh = $(window).height();
	const recalc = () => {
		vh = $(window).height();
		let siteHeaderHeight = $('.site-header').height();
		if ($('body').hasClass('home-page')) position = vh - (siteHeaderHeight * .6666);
		else if ($('body').hasClass('sec-page recruit-page')) position = vh * 3;
		else position = vh * 0.5;
	};
	$(window).off('.isScroll'); // ← まず既存を解除
	$(window).on('resize.isScroll load.isScroll', recalc);
	$(window).on('scroll.isScroll load.isScroll', function(){
		const winTop = $(this).scrollTop();
		if (winTop >= position) {
			if (!showFlag) { showFlag = true; $('body').addClass('is-scroll'); }
		} else {
			if (showFlag) { showFlag = false; $('body').removeClass('is-scroll'); }
		}
	});
	recalc();
}

//navi trigger
function naviTrigger(){
	$('.site-header__trigger').on('click', function(){
		if ($('body').hasClass('navi-close')) {
			$('body').toggleClass('navi-open navi-close');
		} else if($('body').hasClass('navi-open')) {
			$('body').toggleClass('navi-close navi-open');
		}
	});
	$('.main-menu__trigger').on('click', function(){
		$(this).parent('.main-menu__item').toggleClass('is-open');
		$(this).next().slideToggle(200);
	});
	$('.child-menu__anchor').on('click', function(){
		if ($('body').hasClass('navi-close')) {
			$('body').toggleClass('navi-open navi-close');
		} else if($('body').hasClass('navi-open')) {
			$('body').toggleClass('navi-close navi-open');
		}
	});
}

//search trigger
function searchTrigger(){
	$('.search-widget__trigger').on('click', function(){
		$('.search-widget').addClass('is-open');
		$('.mt-site-search-form__query').focus();
	});
	$('.search-widget__close').on('click', function(){
		$('.search-widget').removeClass('is-open');
	});
	const $form = $('.mt-site-search-form');
	const $textarea = $('.mt-site-search-form__query');
	$textarea.on('keypress', function(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			$form.submit();
		}
	});
}

//smooth scroll
function smoothScroll(){
	$('a[href^="#"]').on('click', function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (!target.length) return;
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
}

//accordion
function accordion(){
	$('.accordion__trigger').click(function() {
		$(this).parent().toggleClass('is-open');
		$('.accordion__trigger').not($(this)).parent().removeClass('is-open');
		$(this).next('.accordion__target').slideToggle(300);
		$('.accordion__target').not($(this).next()).slideUp();
	});
}

//split text
function splitText(){
	$('.split-text').each(function(){
		$(this).contents().filter(function() {
			return this.nodeType === 3;
		}).each(function() {
			$(this).replaceWith($(this).text().replace(/(\S)/g, '<span>$&</span>'));
		});
	});
}

//inview
function inView(){
	const ivItems = gsap.utils.toArray('.iv-item');
	if (!ivItems.length) return; // ← .iv-itemが無ければ何もしない
	ivItems.forEach(ivItem => {
		ScrollTrigger.create({
			trigger: ivItem,
			start: 'top 90%',
			toggleClass: { targets: ivItem, className: 'iv-item--active' },
			once: true,
		});
	});
}
